"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledPopper = exports.StyledTypography = exports.ToastMessageContainer = exports.StyledIcon = exports.StyledCloseButton = exports.ToastContainer = exports.classes = void 0;
const material_1 = require("@mui/material");
const styles_1 = require("@mui/material/styles");
const icon_button_1 = __importDefault(require("../icon-button"));
const typography_1 = __importDefault(require("../typography"));
const icon_1 = __importDefault(require("../icon"));
const PREFIX = "Toast";
exports.classes = {
    success: `${PREFIX}-success`,
    fail: `${PREFIX}-fail`,
    warning: `${PREFIX}-warning`,
    informative: `${PREFIX}-informative`
};
exports.ToastContainer = (0, styles_1.styled)(material_1.Snackbar)(({ theme }) => ({
    [`&.${exports.classes.success}`]: {
        "&&": {
            marginTop: "18px"
        },
        [`& .${material_1.snackbarContentClasses.root}`]: {
            backgroundColor: theme.colours.success50,
            margin: 0
        }
    },
    [`&.${exports.classes.fail}`]: {
        "&&": {
            marginTop: "18px"
        },
        [`& .${material_1.snackbarContentClasses.root}`]: {
            backgroundColor: theme.colours.error50,
            margin: 0
        }
    },
    [`&.${exports.classes.informative}`]: {
        "&&": {
            marginTop: "0px"
        },
        [`& .${material_1.snackbarContentClasses.root}`]: {
            backgroundColor: theme.colours.alert50,
            padding: "6px 3px 6px 16px",
            boxShadow: "unset"
        }
    },
    [`&.${exports.classes.warning}`]: {
        "&&": {
            marginTop: "18px"
        },
        [`& .${material_1.snackbarContentClasses.root}`]: {
            backgroundColor: theme.colours.alert50,
            margin: 0
        }
    },
    "&&": {
        position: "unset"
    },
    [`& .${material_1.snackbarContentClasses.root}`]: {
        minHeight: "48px",
        minWidth: "280px",
        maxHeight: "92px",
        maxWidth: "320px",
        borderRadius: "3px",
        padding: "12px 3px 12px 16px",
        justifyContent: "space-between",
        flexGrow: "unset",
        flexWrap: "nowrap",
        [theme.breakpoints.up("md")]: {
            minWidth: "300px",
            maxHeight: "68px",
            maxWidth: "480px"
        },
        [theme.breakpoints.up("lg")]: {
            maxWidth: "600px"
        }
    },
    [`& .${material_1.snackbarContentClasses.message}`]: {
        padding: 0
    },
    [`& .${material_1.snackbarContentClasses.action}`]: {
        margin: 0,
        padding: 0
    }
}));
exports.StyledCloseButton = (0, styles_1.styled)(icon_button_1.default)(({ theme }) => ({
    "&&": {
        color: theme.colours.charcoal
    },
    [`& .${material_1.svgIconClasses.root}`]: {
        width: "20.61px",
        height: "20.61px"
    }
}));
exports.StyledIcon = (0, styles_1.styled)(icon_1.default)(({ theme }) => ({
    [`&.${exports.classes.success}`]: {
        color: theme.colours.success400
    },
    [`&.${exports.classes.fail}`]: {
        color: theme.colours.error400
    },
    [`&.${exports.classes.warning}`]: {
        color: theme.colours.yellow400
    },
    [`&.${exports.classes.informative}`]: {
        color: theme.colours.yellow400
    },
    width: "32px",
    height: "32px",
    [theme.breakpoints.down("sm")]: {
        display: "none"
    }
}));
exports.ToastMessageContainer = (0, styles_1.styled)("div")({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "6px"
});
exports.StyledTypography = (0, styles_1.styled)(typography_1.default)(({ theme }) => ({
    color: theme.colours.charcoal,
    overflowWrap: "anywhere",
    [`&.${exports.classes.informative}`]: {
        fontSize: "18px",
        lineHeight: "21.6px",
        [theme.breakpoints.down("sm")]: {
            fontSize: "14px",
            lineHeight: "16.8px"
        }
    }
}));
exports.StyledPopper = (0, styles_1.styled)(material_1.Popper)({
    zIndex: 99999
});
//# sourceMappingURL=data:application/json;base64,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